import React from 'react'
import classnames from 'classnames'
import { Columns, Icon, LocalizedText, Tooltip, Transition } from 'src/components'
import { mergeProps } from 'src/util'
import { LocalSettingsContext } from 'src/contexts'
import { ArrowLeftIcon } from 'src/components/icons'
import styles from './SidebarToggler.scss'

const tooltipDisabled = state => state === 'exiting' || state === 'exited'
const label = state => (state === 'entered' ? 'WEB_SHOW_MENU' : 'WEB_HIDE_MENU')
const iconReversed = state => state === 'entering' || state === 'entered'

/**
 * An animated sidebar toggler button.
 */
const SidebarToggler = props => {
  const { isSidebarCollapsed, toggleSidebar } = LocalSettingsContext.use()
  return (
    <Transition in={isSidebarCollapsed} timeout={300}>
      {state => (
        <Tooltip
          title={<LocalizedText id={label(state)} />}
          disabled={tooltipDisabled(state)}
          popperProps={{ placement: 'right' }}
        >
          <button {...mergeProps()({ className: styles.toggle }, props)} onClick={toggleSidebar}>
            <Columns align="center" layout="auto" gap="1rem">
              <Icon
                className={classnames(styles.icon, { [styles.reverse]: iconReversed(state) })}
                icon={ArrowLeftIcon}
              />
              <div>
                <LocalizedText id={label(state)} />
              </div>
            </Columns>
          </button>
        </Tooltip>
      )}
    </Transition>
  )
}

export default SidebarToggler
